import { z } from "zod";
import {
  telemetryConnectionStatusSchema,
  highMobilityConnectionPlanSchema,
} from "../_shared";

export const getVehiclesByCompanyResponseSchema = z.array(
  z.object({
    uuid: z.string(),
    vin: z.string(),
    isEligible: z.boolean().nullable(),
    hasTelemetry: z.boolean(),
    dataProvider: z.string().nullable(),
    lastTripsDate: z.iso.datetime().nullable(),
    geolocationError: z.string().nullable(),
    connectionStatus: telemetryConnectionStatusSchema.nullable(),
    brand: z.string().nullable(),
    deviceId: z.string().nullable(),
    deviceLastActivityDate: z.iso.datetime().nullable(),
    connectionRevokedAt: z.iso.datetime().nullable(),
    requestedConnectionAt: z.iso.datetime().nullable(),
    connectionPlan: highMobilityConnectionPlanSchema.nullable(),
    deviceInstalledAt: z.iso.datetime().nullable(),
  }),
);

export type GetVehiclesByCompanyResponse = z.infer<
  typeof getVehiclesByCompanyResponseSchema
>;
